import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DuplicateBorrowerSmartComponent } from './duplicate-borrower-smart/duplicate-borrower-smart.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DuplicateBorrowerDialogComponent } from './duplicate-borrower-dialog/duplicate-borrower-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { TruncateModule } from 'app/pipes/truncate/truncate-pipe.module';
import { MatButtonModule } from '@angular/material/button';
import { PhoneModule } from 'app/pipes/phone/phone-pipe.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    DuplicateBorrowerSmartComponent,
    DuplicateBorrowerDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
    MatTooltipModule,
    TruncateModule,
    PhoneModule,
    RouterModule
  ],
  exports: [
    DuplicateBorrowerSmartComponent,
    DuplicateBorrowerDialogComponent
  ]
})
export class DuplicateBorrowerModule { }
